import { PublicDeleteUserFile, PublicDeleteUserImageByUserAndAccessMethod } from '../../../reduxToolkit/Invitation/InvitationApi';
import { accessMethodModel } from '../../../enums/accessMethodEnum';
import { useEffect } from 'react';
import routes from '../../../Routes/routes';
import { useDispatch } from 'react-redux';
import {ValidationProcessCancel} from '../../../reduxToolkit/Visitor/VisitorApi';
import {getUrlParameters} from "../../Dashboard/Visitor/External/Model/Model";
import {useParams} from "react-router-dom";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model getInvitationById: Model that contains all the information of the invitation.
 * @param String validationId: id of veridas.
 */
const HandleDeleteVeridasApp = ({ getInvitationById, validationId }) => {
    const { guardFlowId } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        if (getInvitationById?.invitation?.id) {
            localStorage.setItem('visitorId', getInvitationById?.invitation?.visitorId);
            localStorage.setItem('invitationId', getInvitationById?.invitation?.id);
            localStorage.setItem('validationId', validationId);
        }
    }, [getInvitationById]);

    const handleGetUrl = () => {
        return getUrlParameters({url: routes.invitationDetails.invitation, id:localStorage.getItem('invitationId'), guardFlowId})
    }

    const handleDelete = () => {
        const userId = localStorage.getItem('visitorId');
        const validation = localStorage.getItem('validationId');
        if (!userId) {
            return;
        }

        dispatch(PublicDeleteUserFile(userId));
        dispatch(PublicDeleteUserImageByUserAndAccessMethod({
            userId,
            accessMethodId: accessMethodModel.FACE_RECOGNITION.id
        }));
        dispatch(ValidationProcessCancel(validation));
    }

    const handleDeleteStorage = () => {
        localStorage.removeItem('visitorId');
        localStorage.removeItem('invitationId');
        localStorage.removeItem('validationId');
    }

    return {
        handleDelete,
        handleDeleteStorage,
        handleGetUrl
    }

};

export default HandleDeleteVeridasApp
